import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useProductReadContext } from '@context/ProductContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const usePersonalInfo = () => {
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()
  const { product } = useProductReadContext()

  const appTestAnswers = useQuery({
    queryKey: queryKeys.personalInfoAppTestAnswers(locale),
    queryFn: () => apiClient.getAccountAppTestAnswers(locale, product),
    enabled: !!locale,
  })

  return { appTestAnswers: { data: appTestAnswers.data, isLoading: appTestAnswers.isLoading } }
}

export const useEconomicProfileAnswers = () => {
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()

  const economicProfileAnswers = useQuery({
    queryKey: queryKeys.economicProfileAnswers(locale),
    queryFn: () => apiClient.getEconomicProfileTestAnswers(locale),
    enabled: !!locale,
  })

  return {
    economicProfileAnswers: {
      data: economicProfileAnswers.data,
      isLoading: economicProfileAnswers.isLoading,
    },
  }
}
